import React, {useEffect} from 'react'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActions from '@mui/material/CardActions';
import { useParams } from "react-router";
import LoadingPageIndicator from '../../../../components/LoadingPageIndicator';
import { useDispatch } from "react-redux";
import { putMessage } from "../../../app/store/actions";
import { useUpdateFeed, useViewFeed } from './feed-hooks';





const FeedViewPage: React.FC<{
    load?: boolean;
  }> = ({
    load = false
  }) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
 

    let { id } = useParams<{ id: string }>();
    const dispatch = useDispatch();
    const {data: feed, isLoading, isFetching, refetch, status } = useViewFeed({
        modelName: 'feed',
        modelId: (parseInt(id!) || 0),
        
   
    }, !!id)

   const updateFeed = useUpdateFeed()

    useEffect(() => {
        if(status === 'error') {
            dispatch(putMessage({type: 'error', message: 'Something went wrong'}))
  
        }
    }, [dispatch, status])
   

    const handleUpdateStatus = async () => {
        if(!feed) return;
        updateFeed.mutate({payload: {isActive: !feed.isActive}, id: feed.id}, {
          onSuccess() {
            dispatch(putMessage({type: 'success', message: `Successfully ${feed.isActive ? 'deactivated' : 'activated'} feed`}))
            refetch();

          },
        })
   
    }
    return (
        <Box sx={{
            width: {
              md: '80vw',
              sm: '100%'
            },
            maxWidth: '800px',
            minWidth: '250px',
            pl: 2
          }}>
   
          {(isLoading || isFetching || updateFeed.isLoading )&& <LoadingPageIndicator />}
   {feed && (       <Card>
            <CardMedia sx={{ height: 125}} title={feed?.title} image={feed?.imageUrl} />
            <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {feed?.title}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
       {feed.excerpt}
        </Typography>
      </CardContent>
      <CardActions>
        <Button onClick={handleUpdateStatus} size="small" color={feed.isActive ? 'error' : 'success'}>{feed.isActive ? 'Deactivate' : 'Activate'} </Button>
      
      </CardActions>
          </Card>
)}
    
          </Box>
    )
}

export default FeedViewPage;
